import { useMemo } from 'react';
import { useProfileV2 } from '#lib/Profile';
import { checkIfInternalUser } from '../utils/isInternalUser';

const useHasCo2ImpactAccess = () => {
  const { profile } = useProfileV2();
  const hasCo2ImpactAccess = useMemo(() => {
    if (!profile) {
      return false;
    }
    const isInternalUser = checkIfInternalUser(profile.email);

    if (isInternalUser) {
      return true;
    }

    return !!profile.permissions?.businessPartners.some((bp) =>
      bp.services.some(
        (service) => service.name === 'services.follow.up.name' && service.co2Impact,
      ),
    );
  }, [profile]);

  return hasCo2ImpactAccess;
};

export default useHasCo2ImpactAccess;
